<template>
    <div class="attr_dialog water-attr">
        <div class="attr_head">
            <el-form ref="form" label-width="40px" class="attr_common" label-position="left">
                <el-form-item label="ID:">
                    <el-input v-model="curProps.id" type="number"></el-input>
                </el-form-item>
            </el-form>
            <div class="btn-array">
                <el-button type="primary" icon="el-icon-check" size="mini" @click="saveProps">保存</el-button>
                <el-button type="primary" icon="el-icon-close" size="mini" @click="resetProps">恢复默认</el-button>
            </div>
        </div>

        <div class="attr_content">

            <el-tabs v-model="activeTab">
                <el-tab-pane label="节点属性" name="properties" class="properties">
                    <el-form ref="form" :model="curProps" label-width="100px" :inline="true">
                        <el-form-item label="标高：" class="attr-item">
                            <el-input v-model="curProps.elevation" type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="需水量：" class="attr-item">
                            <el-input v-model="curProps.demand" type="number"></el-input>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>

                <!--保温设置-->
                <el-tab-pane label="水力参数" name="parameter" class="parameter">
                    <div class="attr_item">
                        <el-checkbox label="压强" name="has_pressure" v-model="curProps.has_pressure"></el-checkbox>
                        <el-input v-model="curProps.pressure" :disabled="!curProps.has_pressure" type="number"></el-input>
                        <span class="attr_unit">Mpa</span>
                    </div>
                    <div class="attr_item">
                        <el-checkbox label="温度" name="has_temp" v-model="curProps.has_temperature"></el-checkbox>
                        <el-input v-model="curProps.temperature" :disabled="!curProps.has_temperature" type="number"></el-input>
                        <span class="attr_unit">℃</span>
                    </div>
                    <div class="attr_item">
                        <el-checkbox label="流量" name="has_flow" v-model="curProps.has_flux"></el-checkbox>
                        <el-input v-model="curProps.flux" :disabled="!curProps.has_flux" type="number"></el-input>
                        <span class="attr_unit">t/h</span>
                    </div>
                </el-tab-pane>
            </el-tabs>

           
        </div>
    </div>
</template>

<script>
/**
 * 连接点属性编辑框
 */
import { mapState } from 'vuex';

export default {
    name:"waterline",
    computed:{
        ...mapState('simulation',[
            'drawSource',
        ]),
        // 当前选中的Feature
        curFeature(){
            return this.$store.state.simulation.curFeatures[0];
        },
    },
     data(){
        return {
            activeTab:"properties", // 显示面板
            
            curProps:{
                id:0,
                elevation:0.0, // 标高
                deman:0.0,// 需水量
            } , // 当前属性
        }
    },
    mounted(){
        // 初始化属性
        this.$nextTick(()=>{
            this.init_props()
        })
    },
    methods:{
        // 初始化属性
        init_props(){
            let nodeProps=this.curFeature?this.curFeature.getProperties():{};
            let props={};

            // 判断是否存在压强属性
            if(nodeProps.hasOwnProperty("pressure")){
                props.pressure=nodeProps.pressure;
                props.has_pressure=true;
            }else{
                props.pressure=0.0;
                props.has_pressure=false;
            }
            // 温度
            if(nodeProps.hasOwnProperty("temperature")){
                props.temperature=nodeProps.temperature;
                props.has_temperature=true;
            }else{
                props.temperature=0.0;
                props.has_temperature=false;
            }
            // 流量
            if(nodeProps.hasOwnProperty("flux")){
                props.flux=nodeProps.flux;
                props.has_flux=true;
            }else{
                props.flux=0.0;
                props.has_flux=false;
            }

            // 替换默认的属性
            let defaultValue=this.$store.getters['simulation/getDefault']("branch");
            props=Object.assign({},defaultValue,nodeProps);
            
            this.curProps=props;
        },
        // 保存修改的属性
        saveProps(){
            let nodeProps=this.curFeature?this.curFeature.getProperties():{};

            /**
             * 根据是否选中温度压力和流量，进行属性的增减
             */
            // 压力
            if(this.curProps.has_pressure){
                nodeProps.pressure=this.curProps.pressure;
            }else{
                delete nodeProps.pressure;
            }
            // 温度
            if(this.curProps.has_temperature){
                nodeProps.temperature=this.curProps.temperature;
            }else{
                delete nodeProps.temperature;
            }
            // 流量
            if(this.curProps.has_flux){
                nodeProps.flux=this.curProps.flux;
            }else{
                delete nodeProps.flux;
            }


            // 修改id号  
            let id=this.curProps.id;
            if(this.checkId(id)){
                this.$message({
                    message:"编号已存在",
                    type:"error",
                    duration:2000
                });
                return;
            }

            nodeProps.id=parseInt(id);
            // 重新应用属性
            let temp=Object.assign({},nodeProps,this.curProps);
            this.curFeature.setProperties(temp);
            // 弹出提示框，提示保存成功
            this.$message({
                message:"保存成功",
                type:"success",
                duration:2000
            });

            // 关闭对话框
            this.$emit("close");

        },
        // 重置属性
        resetProps(){
            // 重新获取属性
            this.init_props();
        },
        // id号判断
        checkId(id){
            let source=this.drawSource;
            let features=source.getFeatures();
            let result=false;
            features.forEach(f=>{
                let _type=f.get("_type");
                // 判断当前图形是不是节点
                if(_type!="line"){
                    let nodeid=f.get("id");
                    if(nodeid==id&&this.curFeature!=f){
                        result=true;
                        return;
                    }
                }
            });
            return result;
        }
    }
}
</script>

<style lang="scss" scoped>
.water-attr{
    position: relative;

    .attr_head{
        overflow: hidden;

        .attr_common{
            width:250px;
            float: left;
        }

        .btn-array{
            position:relative;
            float:right;

            button{
                display: block;
                margin-top: 8px;
                margin-left: 0;
                padding: 5px 3px;
                width: 90px;
                span{
                    cursor: pointer;
                }
            }

            button:first-child{
                margin-top:0;
            }
        }

        .el-input__inner{
            line-height: 35px;
            height: 35px;
        }
    }

    .attr_content{
        padding: 10px;
        border: 1px solid #246bc640;
        border-radius: 4px;
        margin-top: 10px;
        width: 600px;
        height: 320px;

        .el-form{
            display: flex;
            flex-wrap: wrap;
        }

        .attr-item{
            margin-top: 5px;
            margin-right: 0;
            flex: 1 0 50%;

            span{
                font-size: 18px;
            }

            .el-input{
                width: 150px;

                input{
                    height: 30px;
                    line-height: 30px;
                    padding: 0 5px 0 15px;
                }

            }
            .el-select{
                width: 150px;
            }

            .attr_unit{
                margin-left: 10px;
            }
        }

        .parameter{
             .el-input{
                width: 100px;
                margin:0 10px 10px 10px;
            }
        }
    }
}
</style>